import React from "react";
import { PageView } from "./index";

const ViewTabs = ({
  activeTab,
  setActiveTab
}: {
  activeTab: PageView;
  setActiveTab: (activeTab: string) => void;
}) => {
  return (
    <ul className="nav nav-tabs">
      <li className={activeTab === "keywords" ? "active" : ""}>
        <a onClick={() => setActiveTab("keywords")}>Event Name</a>
      </li>
      <li className={activeTab === "date" ? "active" : ""}>
        <a onClick={() => setActiveTab("date")}>
          <span data-toggle="modal" data-target="#month-pop">
            Date
          </span>
        </a>
      </li>
      <li className={activeTab === "history" ? "active" : ""}>
        <a onClick={() => setActiveTab("history")}>Browsing History</a>
      </li>
      <li className={activeTab === "photographer" ? "active" : ""}>
        <a onClick={() => setActiveTab("photographer")}>Photographers</a>
      </li>
    </ul>
  );
};

export default ViewTabs;
